import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { format as formatDate, isDate } from 'date-fns';
import { sv, nb } from 'date-fns/locale';

const locales = {
  sv,
  nb,
};

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: { loadPath: '/fnol/locales/{{lng}}/translation.json' },
    interpolation: {
      format: (value, format, lng) => {
        if (isDate(value)) {
          const locale = locales[lng];
          return formatDate(value, format, { locale });
        }
      },
    },
    debug: false,
    fallbackLng: 'sv',
  });

export default i18n;
